import ImportExportIcon from '@mui/icons-material/ImportExport';
import Button from '@mui/material/Button';
import React from 'react';

import { getExcelFile } from '@sophocles/utils/index';

class InstallServicesBillingExcelButton extends React.Component {
  constructor(props) {
    super(props);
  }

  _buildExcelFile = () => {
    const { data, columns, title, startDate, endDate, firstLine, footer } = this.props;

    // const title = `solar-variance-report-` + Date.now();

    // basic array of column id's

    const headers = [];
    headers.push([firstLine]);
    headers.push([`${startDate} to ${endDate}`]);
    headers.push([]);
    headers.push(columns.map(col => col.get('name')).toJS());

    // first go through and use the cellRenderers if they exist.
    const dataColumns = columns.map(col => col.get('id')).toJS();

    let newData = data;
    // follow the cell renderer if it has one
    columns.forEach(column => {
      if (column.has('cellRenderer')) {
        const id = column.get('id', 0);
        const cellRenderer = column.get('cellRenderer', v => v);
        newData = newData.map(row => row.set(id, cellRenderer(row.get(id, ''), row)));
      }
    });

    getExcelFile(newData, dataColumns, headers, title, null, [[], footer]);
    // list, columns, headers = [[]], title = null, wscols = null, footers=null
  };

  render() {
    return (
      <Button
        variant="contained"
        color="success"
        startIcon={<ImportExportIcon />}
        onClick={() => this._buildExcelFile()}
      >
        Export
      </Button>
    );
  }
}

export default InstallServicesBillingExcelButton;
